/** Keep digits and #. Example: 123# */
export function phoneExtensionInput(value: string): string {
  return value.replace(/[^0-9#]/g, '');
}

export function phoneExtensionError(value: string | undefined): string | null {
  const extension = (value || '').trim();
  if (!extension) return null;
  if (!/^[0-9#]+$/.test(extension)) {
    return 'Use only digits and #, for example 123#.';
  }
  return null;
}
